import { ConfigService } from './../../services/config.service';
import { Length } from 'class-validator';
import { ActViewerService } from './../../services/act-viewer.service';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import * as XLSX from 'xlsx';
import { plmUserRoleEnum } from '../../../submodules/silverlight-common/lib/ts/src/common-enums/user.role.enums';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { sourceSystemEnum } from '../../../submodules/silverlight-common/lib/ts/src/common-enums/source.system.enums';
import { UserService } from '../../services/user.service';
import { CountryListService } from '../../services/country-list.service';
import { ICountryList } from '../../../submodules/silverlight-common/lib/ts/src/interface/country.list.interface';
import { UnsubscribeOnDestroyAdapter } from '../../subscription/unsubscribe-ondestroy-adapter';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedService } from '../../services/shared.service';
import { LogHandler } from '../../helpers/log.handler';
import { logEventEnum } from '../../../submodules/silverlight-common/lib/ts/src/common-enums/log.event.enums';
import UIConstants from '../../../app-constants/ui-constants';
import { MatExpansionModule } from '@angular/material/expansion';
import { IConfigData } from '../../../submodules/silverlight-common/lib/ts/src/interface/config.data.interface';
import { IUserProfile } from '../../../submodules/silverlight-common/lib/ts/src/interface/user.profile.interface';
interface UserLocationinfo {
  region: string;
  countries?: string[];
}

interface UserProductInjector {
  injectorType: string;
  userLicenseExpirationDateTime: string;
  injectorID?: string[];
}

interface User {
  userName: string;
  userFirstName: string;
  userMiddleName?: string;
  userLastName: string;
  userEmailId: string;
  userOrganizationName: string;
  userAssignedRole: keyof typeof plmUserRoleEnum;
  userAssignedSystem: string;
  userLocationinfo: UserLocationinfo[];
  userProductTypes: string[];
  userIsActive: boolean;
  userCreatedBy: string;
  userCreatedBySystemName: string;
  userIsDevToolsAccess: boolean;
  userProductInjectorIDs: UserProductInjector[];
}

@Component({
  selector: 'app-add-bulk-user-modal',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatSnackBarModule,
    MatIconModule,
    MatExpansionModule,
    MatIconModule,
  ],
  templateUrl: './add-bulk-user-modal.component.html',
  styleUrl: './add-bulk-user-modal.component.scss',
})
export class AddBulkUserModalComponent
  extends UnsubscribeOnDestroyAdapter
  implements OnInit {
  fileData: any; // Holds the parsed Excel data
  fileName: string = ''; // Holds the name of the uploaded file
  @ViewChild('fileInput') fileInput!: any; // Reference to the input element

  constructor(
    private dialogRef: MatDialogRef<AddBulkUserModalComponent>,
    private userService: UserService,
    private countryListService: CountryListService,
    private configService: ConfigService,
    private actViewerService: ActViewerService,
    private sharedService: SharedService,
    private _snackBar: MatSnackBar
  ) {
    super();
  }
  ngOnInit(): void {
    this.subs.sink = this.countryListService
      .getCountryList()
      .subscribe((data) => {
        console.log(data);
        this.countryRegionApiData = data?.responseData;
      });
    this.configService.getConfigData().subscribe()
    this.subs.sink = this.configService.configData$.subscribe((data) => {
      if (data) {
        const configDataJson = data?.find((config: IConfigData) => {
          return config?.keyName === 'InjectorTypes';
        })
          ?.keyValue
        const configDataObject = JSON.parse(configDataJson ?? '');
        this.productTypes = Object.keys(configDataObject)
        this.productTypeObject = configDataObject
      }
    })
    this.userService.getPLMUserProfiles().subscribe()
    this.subs.sink = this.userService.userProfileList$.subscribe((data: any) => {
      if (data) {
        this.userList = data?.responseData || []
      }
    })
  }
  addBulkUserConstants = UIConstants.User_Bulk_Add;
  addEditConstants = UIConstants.User_Add_Edit
  countryRegionApiData!: ICountryList[];
  productTypes!: string[]
  productTypeObject!: Record<string, string>;
  userList: IUserProfile[] = []
  currentUserName: string = '';
  listOfBulkUsers: any = [];
  bulkUserErrors: any = {};
  get errorUserNames() {
    return Object.keys(this.bulkUserErrors)
  }

  get countryRegionMap() {
    if (!this.countryRegionApiData || this.countryRegionApiData.length === 0) {
      return {}; // Return an empty object if countryRegionApiData is not set
    }
    return this.countryRegionApiData.reduce((acc: any, current: any) => {
      const { country, region_HQ } = current;

      if (!acc[region_HQ]) {
        acc[region_HQ] = [];
      }

      acc[region_HQ].push(country);
      return acc;
    }, {});
  }

  get submittable(): boolean {
    return this.listOfBulkUsers.length && !Object.keys(this.bulkUserErrors).length;
  }
  downloadTemplate(): void {
    const link = document.createElement('a');
    link.href = '/assets/bulk-user-template.xlsx';
    link.download = 'BulkUserTemplate.xlsx';
    link.click();
  }

  fseDealerProductExpiration(productList: string[]) {
    return productList.map((product) => {
      return {
        injectorType: this.getKeyByValue(product, this.productTypeObject) ?? product.toLowerCase(),
        injectorID: ['ALL'],
        userLicenseExpirationDateTime: this.addEditConstants.FSE_DEALER_EXP_DATE()
      }
    })
  }

  onFileChange(event: any): void {
    //.replace(/\s+/g, "") Removes all white spaces
    this.listOfBulkUsers = [];
    this.bulkUserErrors = {}
    try {
      const onLoadErrors: string[] = [];
      const target: DataTransfer = <DataTransfer>event.target;
      const file = target.files[0];
      console.log(file); // Log the file object
      this.fileName = file.name;
      const reader: FileReader = new FileReader();
      if (
        file.type !==
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        onLoadErrors.push('Invalid file type');
      }
      if (file.name !== 'BulkUserTemplate.xlsx') {
        onLoadErrors.push('Invalid file name, must match: ' + 'BulkUserTemplate.xlsx');
      }
      reader.onload = (e: any) => {
        const arrayBuffer = e.target.result;
        const binaryData = new Uint8Array(arrayBuffer);
        const workbook: XLSX.WorkBook = XLSX.read(binaryData, {
          type: 'array',
        });

        console.log(workbook.SheetNames); // Log the workbook object
        if (workbook.SheetNames.length !== 4) {
          onLoadErrors.push('Invalid number of sheets');
          return;
        }
        workbook.SheetNames.forEach((sheetName) => {
          if (sheetName === 'EXAMPLE') return;
          const sheet: XLSX.WorkSheet = workbook.Sheets[sheetName];
          console.log('Sheet Name: ', sheetName);
          this.fileData = XLSX.utils.sheet_to_json(sheet, {
            header: 0, raw: false,
            defval: ''
          });
          this.fileData.forEach((userFromExcel: any) => {
            for (let key in userFromExcel) {
              if (
                key === 'Authorized Countries' ||
                key === 'Authorized Regions' ||
                key === 'Authorized Products' ||
                key === 'Authorized Product Info'
              )
                continue;
              userFromExcel[key] = userFromExcel[key]
                ?.toString()
                ?.replace(/\s+/g, '');
            }
            let currentUserErrors: any[] = []
            const currentUserExcelRow: any = {
              userName: userFromExcel['User Name'] ?? '',
              userFirstName: userFromExcel['First Name'] ?? "",
              userMiddleName: userFromExcel['Middle Name'] ?? '',
              userLastName: userFromExcel['Last Name'] ?? '',
              userEmailId: userFromExcel['Email'] ?? "",
              userOrganizationName: userFromExcel['Organization Name'] ?? '',
              userAssignedRole: '', // This will be set based on the sheet name
              userAssignedSystem: sourceSystemEnum.PLM,
              userLocationinfo: [],
              userProductTypes:
                userFromExcel['Authorized Products']?.split(',').map((product: string) => {
                  return this.getKeyByValue(product.trim(), this.productTypeObject) ?? product.trim().toLowerCase()
                }) ?? [],
              userIsActive: true,
              userUpdatedBy: '',
              userCreatedBy: this.sharedService.getCurrentUserName ?? '',
              userCreatedBySystemName: UIConstants.General.SYSTEM_NAME ?? '',
              userIsDevToolsAccess: false,
            };
            let countryRegionValidationErrors: string[] = []
            switch (sheetName) {
              case plmUserRoleEnum.FSE: {
                currentUserExcelRow.userAssignedRole = plmUserRoleEnum.FSE;
                countryRegionValidationErrors = this.validateRegionsAndCountries(userFromExcel['Authorized Regions']?.split(',') ?? [], userFromExcel['Authorized Countries']?.split(',') ?? [])
                currentUserExcelRow.userLocationinfo = this.getLocationInfo(
                  userFromExcel['Authorized Countries']
                    ? userFromExcel['Authorized Countries']?.split(',')
                    : [],
                  userFromExcel['Authorized Regions']?.split(','),
                  plmUserRoleEnum.FSE
                );
                currentUserExcelRow.userProductInjectorIDs = this.fseDealerProductExpiration(currentUserExcelRow.userProductTypes)
                break;
              }
              case plmUserRoleEnum.BIOMED: {
                console.log(this.fileData); // Log the parsed data
                currentUserExcelRow.userAssignedRole = plmUserRoleEnum.BIOMED;
                currentUserExcelRow.userProductInjectorIDs = []
                const productInfoArray = userFromExcel[
                  'Authorized Product Info'
                ]
                  ?.split(';')
                  ?.map((productInfo: string) => productInfo?.split('|'));
                if (productInfoArray?.length)
                  for (const productInfo of productInfoArray) {
                    let [
                      injectorType,
                      injectorID,
                      userLicenseExpirationDateTime,
                    ] = productInfo;
                    injectorID = injectorID
                      ?.replace(/\s+/g, '')
                      ?.split(',');
                    currentUserExcelRow.userProductInjectorIDs.push({
                      injectorType: this.getKeyByValue(injectorType?.trim(), this.productTypeObject) ?? injectorType?.trim()?.toLowerCase(),
                      injectorID,
                      userLicenseExpirationDateTime: new Date(userLicenseExpirationDateTime),
                    });
                  }

                break;
              }
              case plmUserRoleEnum.DEALER: {
                console.log(this.fileData); // Log the parsed data
                currentUserExcelRow.userAssignedRole = plmUserRoleEnum.DEALER;
                countryRegionValidationErrors = this.validateRegionsAndCountries(["ALL"], userFromExcel['Authorized Countries']?.split(',') ?? [])
                currentUserExcelRow.userLocationinfo = this.getLocationInfo(
                  userFromExcel['Authorized Countries']?.split(','),
                  [this.addBulkUserConstants.ALL_COUNTRY_REGION],
                  plmUserRoleEnum.DEALER
                );
                currentUserExcelRow.userProductInjectorIDs = this.fseDealerProductExpiration(currentUserExcelRow.userProductTypes)
                break;
              }
              default: {
                onLoadErrors.push(`Invalid sheet name: ${sheetName}`);
                break;
              }
            }
            //Add user to error object
            console.log("THIS IS WHAT THE USER WE ARE PUTTING THROUGH VALIDATION", currentUserExcelRow)
            console.log(currentUserErrors, this.validateUser(currentUserExcelRow), countryRegionValidationErrors)
            currentUserErrors = [...currentUserErrors, ...this.validateUser(currentUserExcelRow, userFromExcel), ...countryRegionValidationErrors]
            console.log("CURRENT USER ERRORS", currentUserErrors.length)
            if (currentUserErrors.length) {
              console.log(currentUserExcelRow.userName, 'has errors')
              this.bulkUserErrors[currentUserExcelRow.userName] = currentUserErrors
            }
            this.listOfBulkUsers.push(currentUserExcelRow);


          });
        });
        if (onLoadErrors.length) {
          if (!this.bulkUserErrors['Load Errors']) {
            this.bulkUserErrors['Load Errors'] = onLoadErrors;
          } else {
            this.bulkUserErrors['Load Errors'] = [...this.bulkUserErrors['Load Errors'], ...onLoadErrors];
          }
          console.log(this.bulkUserErrors)
        }
        if (this.listOfBulkUsers.length === 0) this.bulkUserErrors['Load Errors'] = [...onLoadErrors, 'Must contain one or more users']
        this.checkForDuplicateUsernameOrEmail(this.listOfBulkUsers, this.userList)
        this.fileInput.nativeElement.value = ''
      };
      // Use readAsArrayBuffer instead of readAsBinaryString
      reader.readAsArrayBuffer(file);
    } catch (error) {
      this.listOfBulkUsers = [];
      if (typeof error === 'string') {
        this._snackBar.open(
          'Error reading file: ' + error,
          UIConstants.General.CLOSE_NOTIFICATION,
          {
            duration: 5000,
          }
        );
      } else {
        this._snackBar.open(
          'Error reading file, please check and resubmit',
          UIConstants.General.CLOSE_NOTIFICATION,
          {
            duration: 5000,
          }
        );
      }
    }
  }
  getLocationInfo(
    selectedCountries: string[] = [],
    selectedRegions: string[] = [],
    userType: string
  ): any {
    selectedCountries = selectedCountries.map(item => item.trim())
    selectedRegions = selectedRegions.map(item => item.trim())
    if (userType === plmUserRoleEnum.FSE) {
      const result = selectedRegions.map((region) => {
        if (!selectedCountries) return { region, countries: [] };
        if (
          selectedCountries.length > 0 &&
          selectedCountries[0] === this.addBulkUserConstants.ALL_COUNTRY_REGION
        ) {
          return {
            region: region,
            countries: [this.addBulkUserConstants.ALL_COUNTRY_REGION],
          };
        }
        console.log({
          region,
          countryMAPREGION: this.countryRegionMap[region],
        });
        let filteredCountries!: string[]
        if (this.countryRegionMap[region]) {
          filteredCountries = this.countryRegionMap[region].filter(
            (country: string) => selectedCountries?.includes(country)
          );
        } else {
          filteredCountries = []
        }

        return {
          region: region,
          countries: filteredCountries.length > 0 ? filteredCountries : [],
        };
      });

      return result;
    } else if (userType === plmUserRoleEnum.DEALER) {
      if (
        selectedCountries?.[0] === this.addBulkUserConstants.ALL_COUNTRY_REGION
      ) {
        return [
          {
            region: this.addBulkUserConstants.ALL_COUNTRY_REGION,
            countries: [this.addBulkUserConstants.ALL_COUNTRY_REGION],
          },
        ];
      }
      return [
        {
          region: this.addBulkUserConstants.ALL_COUNTRY_REGION,
          countries: selectedCountries,
        },
      ];
    } else {
      console.log('Invalid user type', userType);
      return [];
    }
  }
  // Method to handle form submission
  submitData(): void {
    console.log(this.listOfBulkUsers);
    if (this.listOfBulkUsers.length === 0) {
      this._snackBar.open(
        'No users to submit',
        UIConstants.General.CLOSE_NOTIFICATION,
        {
          duration: 5000,
        }
      );
      return;
    }
    this.subs.sink = this.userService
      .createBulkUserProfiles(this.listOfBulkUsers)
      .subscribe({
        next: (data) => {
          console.log(data);

          this._snackBar.open(
            `Users: ${this.listOfBulkUsers
              .map((user: any) => user.userName)
              .join(', ')} have been created`,
            UIConstants.General.CLOSE_NOTIFICATION,
            {
              duration: 8000,
            }
          );
          new LogHandler(
            this.sharedService,
            this.actViewerService
          ).captureLogData(
            `Users: ${this.listOfBulkUsers
              .map((user: any) => user.userName)
              .join(', ')} have been created`,
            logEventEnum.INFO
          );
          this.dialogRef.close();
        },
        error: (errorResponse) => {
          console.error(errorResponse.status);
          if (errorResponse.status === 0) {
            this._snackBar.open(
              'Server is not reachable',
              UIConstants.General.CLOSE_NOTIFICATION,
              {
                duration: 5000,
              }
            );
            return;
          }
          this._snackBar.open(
            errorResponse.error.error,
            UIConstants.General.CLOSE_NOTIFICATION,
            {
              duration: 5000,
            }
          );
        },
      });
  }


  validateUser(user: User, userFromExcel?: {}): string[] {
    const errors: string[] = [];
    //Validaste entire user for sql injection params
    const specialCharValidationResult = this.validateConcurrentSpecialChars(userFromExcel)
    if (specialCharValidationResult.length) errors.push(...specialCharValidationResult)
    // Validate userName
    if (!user.userName || !UIConstants.General.REGEX.USERNAME.test(user.userName)) {
      errors.push("Username must be a string of 4-6 alphanumeric characters with no special characters.");
    }

    // Validate name fields
    if (!user.userFirstName) {
      errors.push("First name is required and must be a string.");
    } else if (user.userFirstName.length > 50) {
      errors.push("First name must be less than 50 characters.");
    }
    if (user.userMiddleName && user.userMiddleName.length > 50) {
      errors.push("Middle name must be less than 50 characters.");
    }

    if (!user.userLastName) {
      errors.push("Last name is required and must be a string.");
    } else if (user.userLastName.length > 50) {
      errors.push("Last name must be less than 50 characters.");
    }

    // Validate userEmailId
    if (!user.userEmailId || !UIConstants.General.REGEX.EMAIL.test(user.userEmailId)) {
      errors.push("Email must be a valid email address.");
    } else if (user.userEmailId.length > 50) {
      errors.push("Email must be less than 50 characters.");
    }

    // Validate userOrganizationName
    if (!user.userOrganizationName) {
      errors.push("Organization Name is required and must be a string.");
    } else if (user.userOrganizationName.length > 50) {
      errors.push("Organization Name must be less than 50 characters.");
    }

    // Validate userAssignedRole
    if (!Object.keys(plmUserRoleEnum).includes(user.userAssignedRole)) {
      errors.push(`Assigned Role must be: ${Object.keys(plmUserRoleEnum)}`);
    }

    // Validate userAssignedSystem
    if (user.userAssignedSystem !== sourceSystemEnum.PLM) {
      errors.push("Assigned System must be 'PLM'.");
    }

    // Validate userLocationinfo based on user role
    if (user.userAssignedRole === 'BIOMED' && user.userLocationinfo.length) {
      errors.push(`For ${plmUserRoleEnum.BIOMED}, userLocationinfo should not include region or countries.`);
    }
    if (user.userAssignedRole !== plmUserRoleEnum.BIOMED) {
      if (!Array.isArray(user.userLocationinfo)) {
        errors.push("Location info is required and must be an array of objects.");
      } else {
        user.userLocationinfo.forEach((location, index) => {
          if (!location.region) {
            errors.push(`userLocationinfo[${index}].region is required.`);
          }
          if (user.userAssignedRole === plmUserRoleEnum.DEALER) {
            if (location.region !== 'ALL') {
              errors.push(`For ${plmUserRoleEnum.DEALER}, region must be 'ALL'.`);
            }
            if (!location.countries || location.countries.length === 0) {
              errors.push(`For ${plmUserRoleEnum.DEALER}, countries are required.`);
            }
          }
          if (user.userAssignedRole === 'FSE') {
            if (!Array.isArray(location.countries)) {
              errors.push(`For ${plmUserRoleEnum.FSE}, countries must be an array.`);
            }
            if (location.region === this.addBulkUserConstants.ALL_COUNTRY_REGION) {
              errors.push(`For ${plmUserRoleEnum.FSE}, region cannot be 'ALL'`)
            }
          }
        });
      }
    }
    // Validate userProductTypes
    if (!Array.isArray(user.userProductTypes) || user.userProductTypes.length === 0) {
      errors.push("Authorized Products are required and must contain at least one product.");
    }
    if (!this.arraysContainSameValues(user.userProductTypes, user.userProductInjectorIDs.map(product => product.injectorType)) && user.userAssignedRole === plmUserRoleEnum.BIOMED) {
      errors.push(`All Authorized Products must be mentioned in both Authorized Products and Product Info for ${plmUserRoleEnum.BIOMED} users.`)
    }
    if (this.hasDuplicates(user.userProductTypes) || this.hasDuplicates(user.userProductInjectorIDs.map(product => product?.injectorType))) {
      errors.push('Authorized Products and Authorized Product Info must not contain duplicates.')
    }
    // Validate userIsActive
    if (typeof user.userIsActive !== 'boolean') {
      errors.push("Is Active is required and must be a boolean.");
    }

    // Validate userCreatedBy and userCreatedBySystemName
    if (!user.userCreatedBy) {
      errors.push("userCreatedBy is required and must be a string.");
    }
    if (!user.userCreatedBySystemName) {
      errors.push("userCreatedBySystemName is required and must be a string.");
    }

    // Validate userIsDevToolsAccess
    if (user.userIsDevToolsAccess !== false) {
      errors.push("userIsDevToolsAccess must be false.");
    }

    // Validate userProductInjectorIDs based on user role
    user.userProductInjectorIDs.forEach((injector, index) => {
      if (!injector.injectorType) {
        console.log(`userProductInjectorIDs[${index}].injectorType is required and must be a string.`)
        errors.push("Injector Type is required.");
      }
      if (!injector.userLicenseExpirationDateTime || isNaN(Date.parse(injector.userLicenseExpirationDateTime))) {
        console.log(`userProductInjectorIDs[${index}].userLicenseExpirationDateTime must be a valid date string.`);
        errors.push("License Expiration must be a valid date.")
      } else if (new Date(injector.userLicenseExpirationDateTime) <= new Date()) {
        console.log(`userProductInjectorIDs[${index}].userLicenseExpirationDateTime must be a future date.`);
        errors.push("License Expiration must be a future date.")
      }
      if (user.userAssignedRole === 'BIOMED' && !injector.injectorID) {
        console.log(`For ${plmUserRoleEnum.BIOMED}, userProductInjectorIDs[${index}].injectorID is required and must be an array of strings.`);
        errors.push(`For ${plmUserRoleEnum.BIOMED}, Injector ID's are required.`);
      }
      if (user.userAssignedRole === 'BIOMED' && this.hasDuplicates(injector?.injectorID ?? []))
        if (user.userAssignedRole !== 'BIOMED' && injector.injectorID?.[0] !== 'ALL') {
          console.log(`userProductInjectorIDs[${index}].injectorID should only be provided for BIOMED users.`);
          errors.push(`Injector ID's should only be provided for ${plmUserRoleEnum.BIOMED} users.`);
        }
    });
    // Return errors or valid status
    return errors;
  }
  hasDuplicates(arr: string[]): boolean {
    return new Set(arr).size !== arr.length;
  }
  arraysContainSameValues(arr1: string[], arr2: string[]): boolean {
    if (arr1.length !== arr2.length) {
      return false;
    }
    const sorted1 = arr1.slice().sort((a, b) => a.localeCompare(b));
    const sorted2 = arr2.slice().sort((a, b) => a.localeCompare(b));

    return sorted1.every((val, index) => val === sorted2[index]);
  }
  getKeyByValue<T>(value: T, obj: Record<string, T>): string | undefined {
    return Object?.keys(obj)?.find((key) => obj?.[key] === value);
  }
  validateRegionsAndCountries(
    inputRegions: string[],
    inputCountries: string[],
  ): string[] {
    const errors: string[] = [];
    console.log("validateRegionsAndCountries()", inputCountries, inputRegions);

    // Extract valid regions and countries
    const validRegions = Object.keys(this.countryRegionMap);

    // Validate input regions
    let regionsToValidate: string[] = [];
    if (inputRegions.includes("ALL")) {
      if (inputRegions.length > 1) {
        errors.push(`Invalid input: "ALL" cannot be combined with other regions.`);
      }
      regionsToValidate = validRegions;
    } else {
      const invalidRegions = inputRegions.filter(region => !validRegions.includes(region));
      if (invalidRegions.length > 0) {
        errors.push(`Invalid regions found: ${invalidRegions.join(', ')}`);
      }
      regionsToValidate = inputRegions.filter(region => validRegions.includes(region));
    }

    // Collect all valid countries for the regions to validate
    const validCountriesForRegions = regionsToValidate.flatMap(region => this.countryRegionMap[region]);

    // Validate input countries
    if (inputCountries?.includes("ALL")) {
      if (inputCountries.length > 1) {
        errors.push(`Invalid input: "ALL" cannot be combined with other countries.`);
      }
    } else {
      const invalidCountries = inputCountries?.filter(country => !validCountriesForRegions.includes(country));
      if (invalidCountries.length > 0) {
        errors.push(`Invalid countries found for regions given: ${invalidCountries.join(', ')}`);
      }
    }

    // Check for mismatched countries per region
    if (!inputRegions.includes("ALL") && !inputCountries.includes("ALL")) {
      const unmatchedCountries = inputCountries.filter(
        country => !regionsToValidate.some(region => this.countryRegionMap[region].includes(country))
      );
      if (unmatchedCountries.length > 0) {
        errors.push(`Unmatched countries for given regions: ${unmatchedCountries.join(', ')}`)
      }
    }

    return errors;
  }
  removeDuplicateUsers(users: User[] | IUserProfile[]) {
    const uniqueUsers = new Map();

    for (const user of users) {
      const { userName, userEmailId } = user;
      const usernameKey = `username:${userName.toLowerCase()}`;
      const emailKey = `email:${userEmailId.toLowerCase()}`;
      if (!uniqueUsers.has(usernameKey) && !uniqueUsers.has(emailKey)) {
        uniqueUsers.set(usernameKey, user);
        uniqueUsers.set(emailKey, user);
      }
    }
    return [...new Set(uniqueUsers.values())];
  }
  checkForDuplicateUsernameOrEmail(newUsers: User[], existingUsers: IUserProfile[]): void {
    //Make sure duplicates in existing users do not effect this check


    const users = [...newUsers, ...this.removeDuplicateUsers(existingUsers)]

    const userNameCounts: Record<string, number> = {};
    const userEmailCounts: Record<string, number> = {};

    const duplicateUserNames: string[] = [];
    const duplicateEmails: string[] = [];

    // Count occurrences of userName and userEmailId
    console.log(users.length)
    users.forEach((user) => {
      userNameCounts[user.userName.toLocaleLowerCase()] = (userNameCounts[user.userName.toLocaleLowerCase()] || 0) + 1;
      userEmailCounts[user.userEmailId.toLocaleLowerCase()] = (userEmailCounts[user.userEmailId.toLocaleLowerCase()] || 0) + 1;
    });

    // Identify duplicates
    for (const [userName, count] of Object.entries(userNameCounts)) {
      if (count > 1) duplicateUserNames.push(userName);
    }

    for (const [userEmail, count] of Object.entries(userEmailCounts)) {
      if (count > 1) duplicateEmails.push(userEmail);
    }

    // Build error message
    console.error({ duplicateEmails, duplicateUserNames })
    if (duplicateUserNames.length > 0) {
      this.bulkUserErrors['Duplicate Usernames:'] = [`There can be no duplicate usernames: ${duplicateUserNames.join(", ")}`];
    }
    if (duplicateEmails.length > 0) {
      this.bulkUserErrors['Duplicate Emails:'] = [`There can be no duplicate emails: ${duplicateEmails.join(", ")}`];
    }

  }
  validateConcurrentSpecialChars(
    input: any,
    parentKey: string = ''
  ): string[] {
    const errors: string[] = [];

    // Helper functions for validation
    const hasMoreThanThreeSpecialCharsInARow = (str: string): boolean =>
      /[^a-zA-Z0-9]{4,}/.test(str);

    const isOnlySpecialChars = (str: string): boolean =>
      /^[^a-zA-Z0-9]+$/.test(str);

    const traverse = (obj: any, parentKey: string) => {
      if (typeof obj === 'string') {
        if (hasMoreThanThreeSpecialCharsInARow(obj)) {
          console.log(`The following column: "${parentKey}" cannot contain more than three special characters in succession`)
          errors.push(
            `The following column: "${parentKey}" cannot contain more than three special characters in succession`
          );
        }
        if (isOnlySpecialChars(obj)) {
          console.log(`The following column: "${parentKey}" cannot contain only special characters`)
          errors.push(
            `The following column: "${parentKey}" cannot contain only special characters`
          );
        }
      } else if (Array.isArray(obj)) {
        obj.forEach((value, index) => {
          traverse(value, `${parentKey}[${index}]`);
        });
      } else if (typeof obj === 'object' && obj !== null) {
        Object.keys(obj).forEach((key) => {
          traverse(obj[key], parentKey ? `${parentKey}.${key}` : key);
        });
      }
    };

    traverse(input, parentKey);

    return errors.length > 0 ? errors : [];
  }
  override ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
